import Base from './base'
import { singularize } from '../util.js'
import URI from 'urijs'
import activityFactory from '../activity_factory.js'
import Backbone from '@polleverywhere/backbone'

/*
 * Regex parser of the activity_url attribute with matched groupings:
 *   Group[1] = Activity type, e.g. free_text_poll
 *   Group[2] = Permalink, e.g. NmH6ECD4MdAz8sa
 */
const ACTIVITY_URL_REGEX = /\/\/[\w.^/]+\/([a-z0-9_]+)\/([\w]+)/i

const TYPE_NAME_MAP = {
  clickable_image: 'Clickable Image',
  competition: 'Competition',
  discourse: 'Q&A',
  free_text_poll: 'Open-ended',
  multiple_choice_poll: 'Multiple Choice',
  ranking_poll: 'Rank Order',
  survey: 'Survey',
  word_cloud: 'Word Cloud'
}

/*
 * Example model for /api/examples
 *
 * @namespace Model
 */
export default class ExampleActivity extends Base {
  initialize () {
    this.idAttribute = 'activity_url'
    this.urlRoot = '/api/examples'
  }

  type () {
    if (this.has('activity_type')) {
      return this.get('activity_type')
    }

    let urlType = ''
    const activityUrl = this.get('activity_url')
    if (activityUrl) {
      const matches = activityUrl.match(ACTIVITY_URL_REGEX)
      urlType = matches ? matches[1] : ''
    }
    return singularize(urlType)
  }

  /*
   * Return the activity's base URL comprising of host-domain-port.
   * @return {string}
   */
  getBaseUrl () {
    const uri = new URI(this.get('activity_url'))
    return URI.build({
      protocol: uri.protocol(),
      hostname: uri.hostname()
    })
  }

  /*
   * Return the activity's permalink ID string.
   * @return {string}
   */
  getPermalinkId () {
    const activityUrl = this.has('activity_url')
      ? this.get('activity_url') : ''
    const matches = activityUrl.match(ACTIVITY_URL_REGEX)
    return matches ? matches[2] : ''
  }

  /*
   * Get the humanized version of the type
   *
   * E.g. discourse -> Upvote Downvote
   */
  humanizedType () {
    return TYPE_NAME_MAP[this.type()] || 'Poll'
  }

  /*
   * Get the actual activity model to match this example record. Flash options
   * can optionally be fetched and included.
   * @param {Object} options
   * @return [Promise] Which will be resolved with the activity
   */
  getActivity (options = {}) {
    const url = new URI(this.get('activity_url'))
    const newSegment = url.segment()
    newSegment.unshift('api', 'presenter')
    url.segment(newSegment)

    // Tell backend to include additional data.
    const includes = [
      'poll_instances',
      'options',
      'flash_options'
    ]

    url.query({
      include: includes.join(',')
    })

    return Backbone.ajax({ url: url.toString() }).then((activityJson) => {
      return activityFactory(activityJson)
    })
  }
}
